
import React, { useState } from 'react';

import { Row, Col } from 'antd';

// import 'antd/dist/antd.css';

import UploadSvg from './components/UploadSvg';

import SvgRender from './components/SvgRender';
import { Button, Popover, Input, Radio, Space } from 'antd';

import { stringify } from 'svgson';
import { HexColorPicker } from "react-colorful";

import { DownloadOutlined, ScissorOutlined, FormatPainterOutlined, ZoomInOutlined, ZoomOutOutlined, UndoOutlined, RedoOutlined, FileImageOutlined } from '@ant-design/icons';
import uploadFile from '../../helpers/s3-upload';



const ColoringPageToSvg = () => {

    const [svg, setSvg] = useState();
    const [color, setColor] = useState("#aabbcc");
    const [colorHistory, setColorHistory] = useState(["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"]);
    const [mouseMode, setMouseMode] = useState("fill"); // integer state
    const [zoomValue, setZoomValue] = useState(100); // integer state
    const [isCanvasDisabled, setIsCanvasDisabled] = useState(false); // integer state
    const [cursor, setCursor] = useState(`crosshair`);

    const [svgHistory, setSvgHistory] = useState(new Array(50));
    const [historyIndex, setHistoryIndex] = useState(0);
    // const [startIndex, setStartIndex] = useState(0);
    const [undoActions, setUndoActions] = useState(0);
    const [redoActions, setRedoActions] = useState(0);

    function mod(n, m) {
        return ((n % m) + m) % m;
    }

    const updateColorHistory = () => {
        // console.log("made it");
        if (!colorHistory.includes(color)) {
            let items = [...colorHistory];
            items.push(color);
            items.shift();
            setColorHistory(items);
        }

    }

    const updateSvg = (newSvg) => {
        console.log("undo, redo, history index: ", undoActions, redoActions, historyIndex);
        setUndoActions(undoActions + 1);
        setRedoActions(0);
        let items = Object.assign({}, svgHistory);
        // Make a shallow copy of the item you want to mutate
        let item = JSON.parse(JSON.stringify(newSvg));
        // console.log("item", item);
        //Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[historyIndex] = item;
        //Set the state to our new copy
        setHistoryIndex((historyIndex + 1) % 50);
        setSvgHistory(items);
        setSvg(newSvg);
        // console.log("svgpast: ", svg);
    }

    const undo = () => {
        console.log("undo, redo, history index: ", undoActions, redoActions, historyIndex);
        if (undoActions > 1) {
            // console.log("svgHistory: ", svgHistory);
            console.log("history index: ", (historyIndex - 2) % 50)
            let item = JSON.parse(JSON.stringify(svgHistory[mod(historyIndex - 2, 50)]));;
            setSvg(item);

            setHistoryIndex(mod((historyIndex - 1), 50));
            setUndoActions(undoActions - 1);
            setRedoActions(redoActions + 1);
        }
    }

    const redo = () => {
        console.log("undo, redo, history index: ", undoActions, redoActions, historyIndex);
        if (redoActions > 0) {
            // console.log("svgHistory: ", svgHistory);
            let item = JSON.parse(JSON.stringify(svgHistory[(historyIndex) % 50]));;
            setSvg(item);
            setHistoryIndex((historyIndex + 1) % 50);
            setRedoActions(redoActions - 1);
            setUndoActions(undoActions + 1);
        }
    }

    const download = () => {
        // console.log(groupColors());
        const blob = new Blob([stringify(svg)], { type: 'image/svg+xml' });
        // uploadFile(blob, "svgColoring")
        const url = URL.createObjectURL(blob);

        console.log("link clicked");
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
            'download',
            `trace.svg`,
        );
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
    }

    // const mergeColors = () => {
    //     var tempSvg = svg;
    //     var newChildren = [];
    //     var usedColors = [];

    //     for (let index = 0; index < svg.children.length; index++) {
    //         console.log("the new children are: ",newChildren);
    //         const mergedColorIndex = usedColors.indexOf(svg.children[index].attributes['fill']);
    //         if (mergedColorIndex === -1) {
    //             usedColors.push(svg.children[index].attributes['fill']);
    //             newChildren.push({
    //                 attributes: {
    //                     fill: svg.children[index].attributes['fill']

    //                 },
    //                 children: [
    //                     {
    //                         attributes: {
    //                             d: svg.children[index].attributes['d'],
    //                             stroke: "none",
    //                             "fill-rule": "evenodd",
    //                         }
    //                     }
    //                 ]
    //             });

    //         } else {
    //             newChildren[mergedColorIndex].children.push( {
    //                 attributes: {
    //                     d: svg.children[index].attributes['d'],
    //                     stroke: "none",
    //                     "fill-rule": "evenodd",
    //                 }
    //             }
    //             );

    //         }
    //     }

    //     // for (let colorIndex = 0; colorIndex < usedColors.length; colorIndex++) {
    //     //     var currentColor = usedColors[colorIndex];

    //     //     var childPath = '';
    //     //     for (let index = 0; index < svg.children.length; index++) {

    //     //         if (svg.children[index].attributes['fill'] == currentColor) {
    //     //             childPath += svg.children[index].attributes['d'] + " "


    //     //         }
    //     //     }
    //     //     const child = Object.assign({}, svg.children[0]);
    //     //     const attributes = Object.assign({}, child.attributes);
    //     //     attributes.d = childPath;
    //     //     attributes.fill = currentColor;
    //     //     child.attributes = attributes;
    //     //     newChildren.push(child);
    //     // }


    //     // for (let colorIndex = 0; colorIndex < usedColors.length; colorIndex++) {
    //     //     var currentColor = usedColors[colorIndex];

    //     //     var childPath = '';
    //     //     for (let index = 0; index < props.svg.children.length; index++) {

    //     //         if (props.svg.children[index].attributes['fill'] == currentColor) {
    //     //             childPath += props.svg.children[index].attributes['d'] + " "
    //     //         }
    //     //     }
    //     //     const child = Object.assign({}, props.svg.children[0]);
    //     //     const attributes = Object.assign({}, child.attributes);
    //     //     attributes.d = childPath;
    //     //     attributes.fill = currentColor;
    //     //     child.attributes = attributes;
    //     //     newChildren.push(child);
    //     // }

    //     console.log(newChildren);
    //     tempSvg.children = newChildren;
    //     setSvg(tempSvg);
    // }

    const groupColors = () => {

        var usedColors = [];

        for (let index = 0; index < svg.children.length; index++) {
            if (!usedColors.includes(svg.children[index].attributes['fill'])) {
                usedColors.push(svg.children[index].attributes['fill']);
                //bodyGroups.push();
            }
        }

        var bodyGroups = new Array(usedColors.length);

        for (let index = 0; index < bodyGroups.length; index++) {
            bodyGroups[index] = "<g>";
        }

        const svgHead = `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="${svg.attributes.height}" viewBox="${svg.attributes.viewBox}" version="1.1">`;



        for (let index = 0; index < svg.children.length; index++) {
            var colorIndex = usedColors.indexOf(svg.children[index].attributes['fill'])
            if (colorIndex != -1) {
                bodyGroups[colorIndex] += `<path d="${svg.children[index].attributes['d']}" stroke="none" fill="${svg.children[index].attributes['fill']}" fill-rule="evenodd" />`
            }
        }

        for (let index = 0; index < bodyGroups.length; index++) {
            bodyGroups[index] += "</g>";
        }

        const svgTail = `</svg>`;

        var svgBody = '';
        for (let index = 0; index < bodyGroups.length; index++) {
            svgBody += bodyGroups[index];

        }

        return svgHead + svgBody + svgTail;


    }

    return (
        <div>
            {svg === undefined &&
                <div style={{ height: "calc(100vh - 200px)" }} >
                    <UploadSvg setSvg={updateSvg} />
                </div>
            }
            {svg != undefined &&
                <div>
                    <Row>

                        <Col>
                            <Button onClick={() => { setSvg() }} style={{ width: "100%" }}><FileImageOutlined /> Change Image </Button>
                        </Col>
                        <Col style={{ minWidth: "55px", paddingLeft: "10px" }}>
                            <Row>
                                <Space>
                                    <Popover onVisibleChange={(e) => { setIsCanvasDisabled(e); updateColorHistory(); }} placement="bottomLeft" content={(
                                        <div>
                                            <HexColorPicker color={color} onChange={setColor} />
                                            <Row style={{ paddingTop: "10px" }}>
                                                <div style={{ paddingTop: "10px", borderStyle: "solid", borderColor: "#f0f0f0", backgroundColor: colorHistory[5], width: "35px", height: "35px" }} onClick={() => { setColor(colorHistory[5]) }}></div>
                                                <div style={{ paddingTop: "10px", borderStyle: "solid", borderColor: "#f0f0f0", backgroundColor: colorHistory[4], width: "35px", height: "35px" }} onClick={() => { setColor(colorHistory[4]) }}></div>
                                                <div style={{ paddingTop: "10px", borderStyle: "solid", borderColor: "#f0f0f0", backgroundColor: colorHistory[3], width: "35px", height: "35px" }} onClick={() => { setColor(colorHistory[3]) }}></div>
                                                <div style={{ paddingTop: "10px", borderStyle: "solid", borderColor: "#f0f0f0", backgroundColor: colorHistory[2], width: "35px", height: "35px" }} onClick={() => { setColor(colorHistory[2]) }}></div>
                                                <div style={{ paddingTop: "10px", borderStyle: "solid", borderColor: "#f0f0f0", backgroundColor: colorHistory[1], width: "35px", height: "35px" }} onClick={() => { setColor(colorHistory[1]) }}></div>
                                                <div style={{ paddingTop: "10px", borderStyle: "solid", borderColor: "#f0f0f0", backgroundColor: colorHistory[0], width: "35px", height: "35px" }} onClick={() => { setColor(colorHistory[0]) }}></div>
                                            </Row>
                                            {/* <Input value={color} /> */}
                                        </div>
                                    )} trigger="click">
                                        <div style={{ paddingTop: "10px", borderStyle: "solid", borderColor: "#f0f0f0", backgroundColor: color, width: "35px", height: "35px" }}></div>

                                    </Popover>
                                </Space>
                            </Row>
                            </Col>
                            <Col style={{ minWidth: "100px" }}>
                                <Row>
                                    <Radio.Group defaultValue="fill"
                                        onChange={(e) => {
                                            setMouseMode(e.target.value)
                                            if (e.target.value === "fill") {
                                                setCursor(`crosshair`);
                                            }
                                            else if (e.target.value === "delete") {
                                                setCursor(`crosshair`);
                                            }
                                        }
                                        }

                                    >
                                        <Radio.Button value="fill"><FormatPainterOutlined /></Radio.Button>
                                        <Radio.Button value="delete"><ScissorOutlined /></Radio.Button>
                                    </Radio.Group>
                                </Row>
                            </Col>

                        <Col style={{ minWidth: "100px" }}>
                            <Row>
                                <Radio.Group value="none">
                                    <Radio.Button disabled={(undoActions <= 1)} onClick={() => undo()} value="undo"><UndoOutlined /></Radio.Button>
                                    <Radio.Button disabled={(redoActions <= 0)} onClick={() => redo()} value="redo"><RedoOutlined /></Radio.Button>
                                </Radio.Group>
                            </Row>
                        </Col>
                        <Col style={{ minWidth: "100px" }}>
                            <Row>
                                <Radio.Group value="none">
                                    <Radio.Button onClick={() => setZoomValue(zoomValue + 10)} value="zoom-in"><ZoomInOutlined /></Radio.Button>
                                    <Radio.Button onClick={() => setZoomValue(zoomValue - 10)} value="zoom-out"><ZoomOutOutlined /></Radio.Button>
                                </Radio.Group>
                            </Row>
                        </Col>
                        <Col style={{ minWidth: "100px" }}>
                            <Row>
                                <Button type="primary" onClick={download} icon={<DownloadOutlined />}>
                                    Download
                                </Button>
                            </Row>
                        </Col>

                    </Row>

                    <Row style={{ marginTop: "10px", outline: "1px solid #f0f0f0" }}>
                        <Col flex="auto" style={{ backgroundColor: '#f0f0f0', height: "calc(100vh - 200px)", overflowX: 'scroll', maxWidth: 'calc(100vw - 20px)', cursor: cursor }} >
                            <center>
                                <SvgRender isCanvasDisabled={isCanvasDisabled} svg={svg} color={color} mouseMode={mouseMode} zoomValue={zoomValue} setSvg={updateSvg} />
                            </center>

                        </Col>

                    </Row>
                </div>

            }


        </div>
    );
}


export default ColoringPageToSvg;